module.exports = __webpack_public_path__ + "img/submit.0068ffc5.png";